import { Inject, Injectable, InjectionToken, Optional } from '@angular/core'

import { BehaviorSubject, ReplaySubject } from 'rxjs'

import { NavigationItem } from 'src/app/shared/types/navigation.types'

export const NAVIGATION_ITEMS = new InjectionToken<NavigationItem[]>('Navigation Items')

@Injectable({
    providedIn: 'root',
})
export class NavigationService {

    private _navigationItems$!: BehaviorSubject<NavigationItem[]>;
    private _currentNavigationIndex$ = new ReplaySubject<number>(1);

    /**
     * Constructor
     */
    constructor(
        @Optional() @Inject(NAVIGATION_ITEMS) navigationItems: NavigationItem[],
    ) {
        this._navigationItems$ = new BehaviorSubject<NavigationItem[]>(navigationItems || []);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    get navigationItems() {
        return this._navigationItems$.getValue();
    }

    get navigationItems$() {
        return this._navigationItems$.asObservable();
    }

    get currentNavigationIndex$() {
        return this._currentNavigationIndex$.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Setters
    // -----------------------------------------------------------------------------------------------------

    private set navigationItems(navigationItems: NavigationItem[]) {
        this._navigationItems$.next(navigationItems);
    }

    set currentNavigationIndex(currentNavigationIndex: number) {
        this._currentNavigationIndex$.next(currentNavigationIndex);
    }
    
    set currentNavigationId(currentNavigationId: string) {
        const currentNavigationIndex = this.navigationItems.findIndex(({ id }) => id === currentNavigationId);
        if (currentNavigationIndex === -1) {
            throw new Error(`Cannot find the navigation item with ID ${currentNavigationId} to set as the current navigation`);
        }
        this.currentNavigationIndex = currentNavigationIndex;
    }
}
